import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import ReusableModal from '../../../ExtraComponents/ReusableModal';
import { getChargeBasisAll, deleteChargeBasis, updateStatus } from "../../../ReduxStore/Slice/Pricing/ChargeBasisSlice";
import { useDispatch } from 'react-redux';
import Datatable from '../../../ExtraComponents/ReusableTable2';
import Swal from 'sweetalert2';
import ReactPaginate from "react-paginate";

const AllChargebasis = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));



  const [chargeBasisData, setChargeBasisData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [InputValue, setInputValue] = useState('');



  useEffect(() => {
    getChargeBasisData();
  }, [currentPage, pageSize, InputValue]);

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])


  const getChargeBasisData = async () => {
    const req = {
      agent_id: agent_id,
      page: currentPage,
      limit: pageSize,
      search: InputValue
    };


    await dispatch(getChargeBasisAll(req)).unwrap()
      .then((response) => {
        setLoading(false);
        if (response.status) {
          setChargeBasisData(response.data);
          setTotalRecords(response?.pagination?.total || 0);
        } else {
          setChargeBasisData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
        setLoading(false);
      });
  };



  const handleEdit = (row) => {
    navigate("/admin/pricing/edit-charge-basis", { state: { data: row } });
  };



  const handleDelete = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ff00aa",
      cancelButtonColor: "#616161",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteChargeBasis({ id: row.id, agent_id: agent_id }))
          .then((response) => {
            if (response.payload.status) {
              Swal.fire("Deleted!", response.payload.msg, "success");
              getChargeBasisData();
            } else {
              Swal.fire("Error!", response.payload.msg, "error");
            }
          })
          .catch((error) => {
            console.error("Error deleting charge basis:", error);
          });
      }
    });
  };

  const handleChangeStatus = (row, e, status) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: "You want to change the status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ff00aa",
      cancelButtonColor: "#616161",
      confirmButtonText: "Yes, change it!"
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(updateStatus({ id: row.id, status: status ? "1" : "0", agent_id: agent_id }))
          .unwrap()
          .then((response) => {
            if (response.status) {
              getChargeBasisData();
              Swal.fire("Changed!", "Your status has been changed.", "success");
            }
          })
          .catch((error) => {
            console.error("Error updating charge basis:", error);
          });
      } else {
        e.target.checked = !status;
        getChargeBasisData();
      }
    });
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  };

  const columns = [
    {
      name: "Charge Basis Name",
      selector: (row) => row.name,
      sortable: true,
      width: "40%",
    },
    {
      name: "Type",
      selector: (row) => row.BasisType?.name || "-",
      sortable: true,
      width: "40%",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className='w-100 d-flex align-items-center'>
          <button className="btn fs-4 py-0 px-2" onClick={() => handleEdit(row)}>
            <i className='ri-edit-line'></i>
          </button>
          {row.deleted && (
            <>
              <div className="form-switch px-1">
                <input
                  className="form-check-input ms-0 mt-0"
                  type="checkbox"
                  id={`statusToggle-${row.id}`}
                  checked={row.status === "1"}
                  onClick={(e) => handleChangeStatus(row, e, e.target.checked)}
                />
              </div>
              <button className="btn fs-4 py-0 px-0" onClick={() => handleDelete(row)}>
                <i className='bx bx-trash'></i>
              </button>
            </>
          )}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "20%",
      className: "text-center",
    },
  ];

  return (
    <div>
      <div className="row mb-3">
        <div className="col">
          <h4 className="page-title">Charge Basis</h4>
        </div>
        <div className="col-auto align-self-center">
          <Link to="/admin/pricing/create-charge-basis" className="btn btn-pink" id="Dash_Date">
            <span className="ay-name" id="Day_Name">Create New</span>
          </Link>
        </div>
      </div>

      <section className="section dashboard">
        <div className="row">
          <data className="col-lg-3 datatable-search mb-2">
            <input
              type="text"
              className="search p-2 icon"
              placeholder="Search here"
              value={InputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </data>
          <div></div>
        </div>

        <div className="row">
          <Datatable
            className="mb-2"
            columns={columns}
            data={chargeBasisData}
            filter={true}
            loading={loading}
          />

          {chargeBasisData.length > 0 ? <div>
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />

            <div className="mt-0">

              <select className="perpage-select" value={pageSize} onChange={handlePageSizeChange}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={500}>500</option>
                <option value={0}>{"ALL"}</option>


              </select>

            </div>
          </div> : ""}
        </div>
      </section>
    </div>
  );
};

export default AllChargebasis;
